<template>
  <v-container class="application-form" style="max-width: 600px; margin: 100px auto;">
    <v-card>
      <v-card-title>Apply for Internship In App Genesis</v-card-title>
      <v-card-text>
        <v-form ref="formRef" v-model="isFormValid" @submit.prevent="submitForm">
          <!-- Personal Information -->
          <v-text-field
            label="Student Name *"
            v-model="form.student_name"
            :rules="[v => !!v || 'Name is required']"
            hint="Enter your name exactly as it should appear on the certificate"
            persistent-hint
            outlined
            dense
          ></v-text-field>

          <v-text-field
            label="Email *"
            v-model="form.email"
            :rules="[v => !!v || 'Email is required', v => /.+@.+\..+/.test(v) || 'Invalid email']"
            outlined
            dense
          ></v-text-field>

          <v-text-field
            label="Mobile Number *"
            v-model="form.mobile_number"
            :rules="[v => !!v || 'Mobile Number is required', v => /^\d{10}$/.test(v) || 'Mobile Number must be 10 digits']"
            outlined
            dense
            @keypress="onlyNumbers($event)"
          ></v-text-field>

          <v-select
            label="Internship Type *"
            v-model="form.internship_type"
            :items="internshipTypeOptions"
            :rules="[v => !!v || 'Internship type is required']"
            outlined
            dense
          ></v-select>

          <!-- Course and Internship Details -->
          <v-select
            label="Course *"
            v-model="form.course"
            :items="internshipOptions" 
            :rules="[v => !!v || 'Course is required']"
            outlined
            dense
          ></v-select>

          

          <v-select
            label="Duration (Months) *"
            v-model="form.duration"
            :items="[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]"
            :rules="[v => !!v || 'Duration is required']"
            outlined
            dense
          ></v-select>

          <!-- College Information -->
          <!-- College Information -->
          <v-text-field
            label="College Name *"
            v-model="form.college_name"
            :rules="[v => !!v || 'College Name is required']"
            hint="Enter full college name clearly"
            persistent-hint
            outlined
            dense
          ></v-text-field>

          <v-text-field
            label="Registration Number *"
            v-model="form.registration_number"
            :rules="[v => !!v || 'Registration Number is required']"
            hint="College Regd No / Student ID (For Certification)"
            persistent-hint
            outlined
            dense
          ></v-text-field>

          <v-text-field
            label="Affiliated University *"
            v-model="form.affiliated_university"
            :rules="[v => !!v || 'University Name is required']"
            hint="Enter full university name"
            persistent-hint
            outlined
            dense
          ></v-text-field>

          <v-text-field
            label="Branch/Group Name *"
            v-model="form.branch_name"
            :rules="[v => !!v || 'Branch Name is required']"
            outlined
            dense
          ></v-text-field>

          <v-text-field
            label="Admission Year *"
            v-model="form.admission_year"
            :rules="[
              v => !!v || 'Admission Year is required',
              v => /^\d{4}-\d{2}$/.test(v) || 'Invalid format (YYYY-YY)'
            ]"
            hint="Enter in format: 2022-23"
            persistent-hint
            outlined
            dense
          ></v-text-field>

          <v-text-field
            label="Specialization *"
            v-model="form.specialization"
            :rules="[v => !!v || 'Specialization is required']"
            hint="e.g., B.Sc.-Mathematics-Physics-Computer Science"
            persistent-hint
            outlined
            dense
          ></v-text-field>

          <!-- Payment Information -->
          <v-radio-group
            v-model="form.already_paid"
            row
            label="Already Paid? *"
            class="mt-3 mb-3"
          >
            <v-radio label="No" :value="false"></v-radio>
            <v-radio label="Yes" :value="true"></v-radio>
          </v-radio-group>

          <!-- Fields for already paid users -->
          <template v-if="form.already_paid">
            <v-text-field
              label="UTR Number *"
              v-model="form.utr_number"
              :rules="[v => !!v || 'UTR Number is required']"
              outlined
              dense
            ></v-text-field>

            <v-text-field
              label="Already Paid Amount *"
              type="number"
              v-model="form.already_paid_amount"
              :rules="[
                v => !!v || 'Amount is required',
                v => parseFloat(v) > 0 || 'Amount must be greater than 0'
              ]"
              outlined
              dense
            ></v-text-field>

            <v-menu
              v-model="dateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  label="Payment Date *"
                  v-model="form.payment_date"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  :rules="[v => !!v || 'Payment Date is required']"
                  outlined
                  dense
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="form.payment_date"
                @input="dateMenu = false"
                :max="new Date().toISOString().substr(0, 10)"
              ></v-date-picker>
            </v-menu>
          </template>

          <!-- Field for unpaid users -->
          <v-text-field
            v-else
            label="Internship Amount *"
            type="number"
            v-model="form.internship_amount"
            :rules="[
              v => !!v || 'Amount is required',
              v => parseFloat(v) > 0 || 'Amount must be greater than 0'
            ]"
            outlined
            dense
            hint="Edit the amount as per your college"
          ></v-text-field>

          <v-text-field
            label="APP GENESIS INTERN ID (Optional)"
            v-model="form.intern_id"
            hint="If already received offer letter, enter ID here"
            persistent-hint
            outlined
            dense
          ></v-text-field>

          <!-- Mentor Information -->
          <v-text-field
            label="College Mentor Name (Optional)"
            v-model="form.college_mentor_name"
            outlined
            dense
          ></v-text-field>

          <v-text-field
            label="College Mentor Email (Optional)"
            v-model="form.college_mentor_email"
            outlined
            dense
          ></v-text-field>

          <v-text-field
            label="College Mentor Mobile Number (Optional)"
            v-model="form.college_mentor_mobile_number"
            outlined
            dense
            @keypress="onlyNumbers($event)"
          ></v-text-field>

          <!-- Additional Information -->

          <v-text-field
            label="Referred By (Optional)"
            v-model="form.referred_by"
            outlined
            dense
          ></v-text-field>

          <div class="text-center">
            <v-btn type="submit" color="primary" :disabled="!isFormValid">Submit</v-btn>
          </div>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>


<script>
import axios from 'axios';

export default {
  data() {
    return {
      form: {
        student_name: '',
        email: '',
        mobile_number: '',
        course: '',
        internship_type: 'SHORT',
        duration: 1,
        college_name: '',
        registration_number: '',
        affiliated_university: '',
        branch_name: '',
        admission_year: '',
        specialization: '',
        college_mentor_name: '',
        college_mentor_email: '',
        college_mentor_mobile_number: '',
        already_paid: false,
        internship_amount: '1000',
        utr_number: '',
        payment_date: '',
        already_paid_amount: '',
        intern_id: '',
        referred_by: ''
      },
      dateMenu: false,
      internshipOptions: [],
      internshipTypeOptions: [
        { value: 'SHORT', text: 'Short Term' },
        { value: 'LONG', text: 'Long Term' }
      ],
      isFormValid: false,
      prod_url: 'app.appgenesis.in',
      dev_url: 'localhost:8000',
      url: 'app.appgenesis.in'
    };
  },

  mounted() {
    this.fetchInternships();
  },
  watch: {
  'form.internship_type': function(newValue) {
    // Refresh the internships list when internship type changes
    this.fetchInternships();
  }
},

  methods: {
    async fetchInternships() {
      try {
        const response = await axios.get(`https://${this.url}/api/internships/`);
        
        // Filter internships based on the selected internship_type
        const filteredInternships = response.data.filter(internship => 
          internship.internship_type === this.form.internship_type
        );
        
        // Map the filtered API response to match the select component format
        this.internshipOptions = filteredInternships.map(internship => ({
          value: internship.id,
          text: internship.name,
        }));
      } catch (error) {
        console.error('Error fetching internships:', error);
      }
    },

    async submitForm() {
      if (!this.isFormValid) {
        console.error('Form validation failed');
        return;
      }

      try {
        const response = await axios.post(`https://${this.url}/api/initiate-payment/`, {
          user: this.form,
          amount: this.form.amount,
        });

        if (this.form.already_paid) {
          // Redirect to success page for already paid users
          this.$router.push({
            name: 'AlreadyPaidStatus',
            params: { 
          userData: response.data.user  // Use the response data from backend
        }
          });
        } else {
          // Redirect to payment gateway for new payments
          window.location.href = response.data.payment_url;
        }
      } catch (error) {
        console.error('Error submitting form:', error);
      }
    },

    onlyNumbers(event) {
      const charCode = event.which ? event.which : event.keyCode;
      if (charCode < 48 || charCode > 57) {
        event.preventDefault();
      }
    }
  }
};
</script>

<style scoped>
.application-form {
  display: flex;
  justify-content: center;
}
</style>
